export default __webpack_public_path__ + "b82e24fb68a3ce5dd83790f0f5aa8d89.png";